const Demand = [
    {
        id : 1 ,
        title : 'Blockchain',
        menu : 'Most In Demand' ,
        tipe : 'Webinar',
        program : 'Supporting',
        short_description : 'Understanding blockchain as a technology that has values of trust, integrity, and traceability that are beneficial for business sustainability.' ,
        description : 'By joining this course, you will get the chance to get learning experience of blockchain, both in the theoretical and practical sense. Not only will you learn the potential of Blockchain data for business as well as improving data security and immutability, but you will be given the guidance to build your own Blockchain! ',
        description_list : [
            'Unlocking The Potential of Blockchain for Business ', 
            'Building a Transparent and Traceable Supply Chain with Blockchain ', 
            'How Blockchain Technology Improve Data Security & Immutability ', 
            'Build Your Own Blockchain: A Practical Guide to Distributed Ledger Technology ', 
            'The Blockchain Developer: A Practical Guide for Designing, Implementing, and Securing Distributed Blockchain-based Projects', 
        ],
        modul : [],
        minimum_participan : 20 ,
        maximum_participan : 30 ,
        link_img : '/courses/blockchain.png',
        is_hot_topic : true
    },
    {
        id : 2 ,
        title : 'Territory Management',
        menu : 'Most In Demand' ,
        tipe : 'Workshop & Webinar',
        program : 'All Entry',
        short_description : 'Understanding the potential of the territory, determining priorities, and optimizing your business.',
        description : 'This course is designed to give a deeper understanding and establish the importance of efficient territory management for your business. Keeping up with the theme, you will also be trained in using analytics tools to measure your territory management and to optimize your sales territory.',
        description_list : [
            'Best Practices in Territory Management',
            'Measures for Territory Management with Analytical Tools',
            'Sales Territory Optimization with Visual Analytics Tools',
        ],
        modul : [],
        minimum_participan : 20 ,
        maximum_participan : 30 ,
        link_img : '/courses/teritory.png',
        is_hot_topic : true
    },
    {
        id : 3 ,
        title : 'Inventory Management',
        menu : 'Most In Demand' ,
        tipe : 'Webinar',
        program : 'Supporting',
        short_description : 'One of the fundamental blocks of business development is inventory management. Throughout this course, you will be trained to shift into digital inventory management by using analytics to manage them. ' ,
        description : 'One of the fundamental blocks of business development is inventory management. Throughout this course, you will be trained to shift into digital inventory management by using analytics to manage them. ' ,
        description_list : [
            'Using Analytics to Manage Inventory',
        ],
        modul : [],
        minimum_participan : 20 ,
        maximum_participan : 30 ,
        link_img : '/courses/inventory.png',
        is_hot_topic : false
    },
    {
        id : 4 ,
        title : 'Data Science',
        menu : 'Most In Demand' ,
        tipe : 'Workshop',
        program : 'Executive',
        short_description : 'Data Science course is designed for those of you who want to elevate your company strategic planning and decision-making straight from the information hidden in your organizations data. ',
        description : 'Data Science course is designed for those of you who want to elevate your company strategic planning and decision-making straight from the information hidden in your organizations data. You will learn to combine the power of statistics, advanced analytics, specialized programming and machine learning with our subject experts to uncover actionable insights for your company.',
        description_list : [],
        modul : [],
        minimum_participan : 20 ,
        maximum_participan : 30 ,
        link_img : '/courses/data-science.png',
        is_hot_topic : false
    },
    {
        id : 5 ,
        title : 'Data Governance & Data Integrity',
        menu : 'Most In Demand' ,
        tipe : 'Workshop & Webinar',
        program : 'All Entry',
        short_description : 'This course helps participants to under-stand the concept about Data Governance and Data Integrity.',
        description : `This course helps participants to understand the concept about Data Governance and Data Integrity. The topic is important for knowing the data we have is consistent and trustworthy and doesn't get misused. This journey enables you to:` ,
        description_list : [
            'Governing the definition of data.',
            'Ensure that data is used properly to avoid introducing data errors into systems',
            'Have the ownership and accountability of data and its use within the company.',
            'Harmonize the data in those systems through a collaborative process',
        ],
        modul : [],
        minimum_participan : 20 ,
        maximum_participan : 30 ,
        link_img : '/courses/data-gov.png',
        is_hot_topic : false
    },
    {
        id : 6 ,
        title : 'Data Storytelling',
        menu : 'Most In Demand' ,
        tipe : 'Webinar',
        program : 'Supporting',
        short_description : 'This course helps participants to get a better understanding of how to tell the audience about the data. ' ,
        description : 'This course helps participants to get a better understanding of how to tell the audience about the data.  Through well-designed data storytelling, the participants are expected to have a particular skill when presenting data to specific stakeholders efficiently and unbiasedly​. This Journey Enables you to:' ,
        description_list : [
            'Practice of building a narrative around a set of data​',
            'Display the suitable data according to the type of audience​',
            'Convey the meaning of your data in a powerful and compelling fashion.​',
        ],
        modul : [],
        minimum_participan : 20 ,
        maximum_participan : 30 ,
        link_img : '/courses/data-story.png',
        is_hot_topic : false
    },
    {
        id : 7 ,
        title : 'Fraud Detection & Fraud Analytics',
        menu : 'Most In Demand' ,
        tipe : 'Workshop',
        program : 'Executive',
        short_description : 'You Will learn how to create and utilize the framework of an Early Warning System to Detect, Predict, and Assess Fraud in Your Business.' ,
        description : 'Wanting to make sure your business’s security and integrity? Then this course is for you! By joining with the Fraud Detection & Fraud Analytics course, you will learn how to create and utilize the framework of an Early Warning System to Detect, Predict, and Assess Fraud in Your Business.' ,
        description_list : [
            'Business Lending Fraud Detection  ',
            'The Fraud Management to Uncovering Fraud in Core Business Systems  ',
            'How to Ensure Data Integrity in Your Organization  ',
            'Conceptual Framework for an Early Warning System to Detect, Predict, and Assess Fraud in Your Business ',
            'Operational Risk Management  ',
            'Fraud Management and Fraud Detection',
        ],
        modul : [],
        minimum_participan : 20 ,
        maximum_participan : 30 ,
        link_img : '/courses/fraud.png',
        is_hot_topic : false
    },
]


//
//
//                              Hot Topics
//
//



const Dojo = [
    {
        id : 1 ,
        title : 'Data Analytics for Supporting Function',
        menu : 'Dattabot Dojo Programs' ,
        tipe : 'Workshop',
        program : 'Supporting',
        short_description : 'Become a data analyst in the designated function who transforms data-driven decision making into acceptable actionable outcomes.',
        description : 'The Data Analytics for Supporting Function course is for those of you who are interested in learning more about how data analytics can transform your business. One of the key strategies is to implement Descriptive, Predictive, and Prescriptive Analytics for data-driven decision-making, implement Customer Service and Business Optimization, and use Early Warning systems to leverage data.',
        description_list : [
            'How Data Analytics Can Transform Your Business',  
            'Implementation of Descriptive, Predictive, and Prescriptive Analytics for Data-Driven Decision-Making',  
            'Customer Analytics and Business Optimization',  
        ],
        modul : [  
        'Introduction to Big Data',
        'Basic Statistic',
        'Phyton Fundamental',
        'Data Preprocessing',
        'Power BI​',
        'DAX',
        'Data Storytelling',
        'Introduction to Database'],
        minimum_participan : 20 ,
        maximum_participan : 30 ,
        link_img : '/courses/data-analytics.png',
        is_hot_topic : false
    },
    {
        id : 2 ,
        title : 'Digital Leadership',
        menu : 'Dattabot Dojo Programs' ,
        tipe : 'Webinar',
        program : 'All Entry',
        short_description : 'Become a data storyteller who transforms data-driven decision-making into acceptable actionable outcomes.' ,
        description : 'Become a data storyteller who transforms data-driven decision-making into acceptable actionable outcomes.',
        modul : [
            'Digital Leadership​',
            'Design Thinking​',
            'Driving Innovation​',
            'Agile Fundamental',
            'Project Management​',
            'Product Management​',
            'Decision-Making for Leaders​',
            'Business Process Analyst​',
        ],
        minimum_participan : 20 ,
        maximum_participan : 30 ,
        link_img : '/courses/digital-leadership.png',
        is_hot_topic : false
    },
    {
        id : 3 ,
        title : 'Advance Analytics',
        menu : 'Dattabot Dojo Programs' ,
        tipe : 'Webinar',
        program : 'Supporting',
        short_description : 'Become a data analyst in the designated function who transforms data-driven decision making into acceptable actionable outcomes.' ,
        description : 'Become a data analyst in the designated function who transforms data-driven decision making into acceptable actionable outcomes.',
        modul : [
            'NLP / Sentiment Analysis',
            'Visual Analysis Advanced​',
            'Spatial Analysis',
            'Big Data and Hadoop​',
            'Intermediate Phython​',
            'Data Manipulation with Pandas​',
            'Joining Data with Pandas ​',
            'Explanatory Data Analysis in Python​',
            'Supervised Learning with scikit-learn​',
        ],
        minimum_participan : 20 ,
        maximum_participan : 30 ,
        link_img : '/courses/advance-ana.png',
        is_hot_topic : false
    },
    {
        id : 4 ,
        title : 'Business Intelligence for Executive',
        menu : 'Dattabot Dojo Programs' ,
        tipe : 'Workshop',
        program : 'Supporting',
        short_description : 'This course helps participants to understand the concept of business intelligence, dashboarding, and visualizing using Microsoft Power BI.',
        description : 'No method is better than showing the data through a visual board. This course helps participants to understand the concept of business intelligence, dashboarding, and visualizing using Microsoft Power BI. Participants will learn how to make a compelling dashboard that will effectively present the raw data.​ This Journey Enables you to:',
        description_list : [
            'Increases efficiency of operational processes.​',
            'Gather the accurate and rich insights from the data provided​.',
            'Set clear benchmarks based on historical and current data.​',
            'Create analysis that can be shared in real-time across departments.​',
        ],
        modul : [
            'Introduction to Big Data',
            'Data Storytelling',
            'Solution Vision & Data Analysis​',
        ],
        minimum_participan : 20 ,
        maximum_participan : 30 ,
        link_img : '/courses/bussiness-intell.png',
        is_hot_topic : false
    }
]



//
//
//              Comments 
//
//



const Comment = [
    {
        name : 'Dwi Wulandari' ,
        division : 'Network',
        course : 'Data Analytics for Supporting Function',
        comment : 'Training yang sangat bermanfaat dan dapat menambahkan skill baru bagi kami terkait proses data analytics dan visualisasi data.',
        link_profile : ''
    } ,


    {
        name : 'Muhammad Fauzi Rais' ,
        division : 'Finance',
        course : 'Data Analytics for Supporting Function',
        comment : 'Model trainingnya bagus, tidak hanya learn theory in class aja, tapi juga ada prakteknya. Selain itu, setelah selesai kelas, juga ada capstone project yang cukup membantu peserta untuk mendalami materi dan belajar menyelesaikan mini project bersama semua anggota kelompok.',
        link_profile : ''
    } ,

    {
        name : 'Juni Widianto' ,
        division : 'Sales',
        course : 'Data Analytics for Supporting Function',
        comment : 'Sangat bagus training data analytic ini untuk improvement monitoring report yang selama ini masih manual pakai Excel jadi bisa lebih dinamis dengan menggunakan Power BI.',
        link_profile : ''
    },

    {
        name : 'Prihadias Murihutomo' ,
        division : 'Marketing',
        course : 'Business Intelligence for Executive',
        comment : 'Penyampaian materinya sangat engaging dan practical use case yang disampaikan sangat relevan.',
        link_profile : ''
    },

    {
        name : 'Andhyka Soemarsono' ,
        division : 'Insurance Company',
        course : 'Data Storytelling',
        comment : 'Dalam asuransi data keuangan, kami melihat bahwa strategi pengolahan data sangat penting karena membuka wawasan untuk mendukung pengambilan keputusan.',
        link_profile : ''
    }
]



const Course = [
    {
        id : 0 ,
        category : "Webinar" , 
        type : "Supporting" , 
        title : "Data Scientics" ,
        link : '/courses?id=0' ,
        topic : 'Most In-Demand' ,
        img : "./Demand/storyTel.png" ,
        body : "Become a data storyteller who transforms data-driven decision-making into acceptable actionable outcomes." ,
        content : 
            {
                description : "" ,
                detail : [ 
                   
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,

    {
        id : 1 ,
        category : "Workshop & Webinar" , 
        type : "All Entry" , 
        title : "Territory Management" ,
        link : '/courses?id=1#course' ,
        topic : 'Most In-Demand' ,
        img : "./Demand/storyTel.png" ,
        body : "Understanding the potential of the territory, determining priorities, and optimizing your business." ,
        content : 
            {
                description : "This course is designed to give a deeper understanding and establish the importance of efficient territory management for your business. Keeping up with the theme, you will also be trained in using analytics tools to measure your territory management and to optimize your sales territory." ,
                detail : 
                    `<li>Best Practices in Territory Management</li>  
                    <li>Measures for Territory Management with Analytical Tools</li>  
                    <li>Sales Territory Optimization with Visual Analytics Tools</li>`
                ,
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,


    {
        id : 2 ,
        category : "Workshop" , 
        type : "Executive" , 
        title : "UX Researcher & UX Analyze Data" ,
        link : '/courses?id=2#course' ,
        topic : 'Most In-Demand' ,
        img : "./Demand/storyTel.png" ,
        body : "Become a data analyst in the designated function who transforms data-driven decision making into acceptable actionable outcomes." ,
        content : 
            {
                description : "" ,
                detail : [ 
                    
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,

    {
        id : 3 ,
        category : "Workshop" , 
        type : "Executive" , 
        title : "Data Analytics " ,
        link : '/courses?id=3#course' ,
        topic : 'Most In-Demand' ,
        img : "./Demand/storyTel.png" ,
        body : "Become a data analyst in the designated function who transforms data-driven decision making into acceptable actionable outcomes." ,
        content : 
            {
                description : "The Data Analytics for Supporting Function course is for those of you who are interested in learning more about how data analytics can transform your business. One of the key strategies is to implement Descriptive, Predictive, and Prescriptive Analytics for data-driven decision-making, implement Customer Service and Business Optimization, and use Early Warning systems to leverage data." ,
                detail : [ 
                    "How Data Analytics Can Transform Your Business" ,  
                    "Implementation of Descriptive, Predictive, and Prescriptive Analytics for Data-Driven Decision-Making" ,  
                    "Customer Analytics and Business Optimization " ,
                    "How An Early Warning System Can Leverage Data in Your Business" ,
                    "Using Statistics for Data-Driven Decisions" ,
                    "Using Data Analysis Tools to Improve Your Organization's Decision Making and Strategy" ,
                    "Descriptive Statistics for Data-driven Decision Making with Analytical Tools" ,
                    "Revolutionizing Business Decision Making using Predictive Analytics with Analytical Tools"
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,

    {
        id : 4 ,
        category : "Webinar" , 
        type : "All Entry" , 
        title : "Data Governance & Data Integrity" ,
        link : '/courses?id=4' ,
        topic : 'New' ,
        img : "./Demand/storyTel.png" ,
        body : "This course helps participants to under-stand the concept about Data Governance and Data Integrity." ,
        content : 
            {
                description : "This course helps participants to understand the concept about Data Governance and Data Integrity. The topic is important for knowing the data we have is consistent and trustworthy and doesn't get misused. This journey enables you to:" ,
                detail : [ 
                    "Governing the definition of data." ,
                    "Ensure that data is used properly to avoid introducing data errors into systems" ,
                    "Have the ownership and accountability of data and its use within the company." ,
                    "Harmonize the data in those systems through a collaborative process"
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,

    {
        id : 5 ,
        category : "Workshop" , 
        type : "Executive" , 
        title : "Inventory Management" ,
        link : '/courses?id=5' ,
        topic : 'New' ,
        img : "./Demand/storyTel.png" ,
        body : "Improve the perspective and management of inventory data to become a building block for future inventory demand forecasting." ,
        content : 
            {
                description : "One of the fundamental blocks of business development is inventory management. Throughout this course, you will be trained to shift into digital inventory management by using analytics to manage them. " ,
                detail : [ 
                    "Using Analytics to Manage Inventory"
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,

    {
        id : 6 ,
        category : "Workshop" , 
        type : "All Entry" , 
        title : "Big Data Analytics" ,
        link : '/courses?id=6' ,
        topic : 'New' ,
        img : "./Demand/storyTel.png" ,
        body : "Big Data is a fundamental aspect of data-driven decision-making. " ,
        content : 
            {
                description : "" ,
                detail : [ 
                    
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,

    {
        id : 7 ,
        category : "Webinar" , 
        type : "All Entry" , 
        title : "Data Storytelling" ,
        link : '/courses?id=7' ,
        topic : 'New' ,
        img : "./Demand/storyTel.png" ,
        body : "This course helps participants to get a better understanding of how to tell the audience about the data. " ,
        content : 
            {
                description : "This course helps participants to get a better understanding of how to tell the audience about the data.  Through well-designed data storytelling, the participants are expected to have a particular skill when presenting data to specific stakeholders efficiently and unbiasedly. This Journey Enables you to:" ,
                detail : [ 
                    "Practice of building a narrative around a set of data" ,
                    "Display the suitable data according to the type of audience",
                    "Convey the meaning of your data in a powerful and compelling fashion"
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,


    {
        id : 8 ,
        category : "Workshop" , 
        type : "All Entry" , 
        title : "Storyboarding" ,
        link : '/courses?id=8' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "This course helps participants to understand how to compose a comprehensive way of thinking through data." ,
        content : 
            {
                description : "This course helps participants to understand how to compose a comprehensive way of thinking through data. Through a scientific structure, participants will create a journey of data through a storyboard. Therefore, participants are expected to show the meaning of the data as business goals. This Journey Enables you to:" ,
                detail : [ 
                    "Convey stories in a structured manner according to the delivery objectives" ,
                    "Visually present information and your business insights in a powerful way" 
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,


    {
        id : 9 ,
        category : "Workshop" , 
        type : "All Entry" , 
        title : "Big Data in Business Sector" ,
        link : '/courses?id=9' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "Implementation of Big Data Analytics in the enterprise can boost many performances." ,
        content : 
            {
                description : "Implementation of Big Data Analytics in the enterprise can boost many performances. This course helps participants understand the basic concept of Big Data, including Big Data use cases commonly used in the Business Sector, like Telecommunications, Legal, Human Resources, etc. This Journey Enables you to:" ,
                detail : [ 
                    "Understand the application of big data in various sectors" ,
                    "Observe and understand consumer needs and preferences through their online behavior." ,
                    "Gather greater insights into customer behavior through data mining and data analytics. "
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,


    {
        id : 10 ,
        category : "Webinar" , 
        type : "Supporting" , 
        title : "Python Fundamental" ,
        link : '/courses?id=10' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "Python as a programming language has been a popular and most simple tool to interpret a wide variety of data." ,
        content : 
            {
                description : "Python as a programming language has been a popular and most simple tool to interpret a wide variety of data. This course helps participants to understand the basics of algorithms and programming using Python as the programming language. Through this course and its use case, the participants can implement their new skills to real-world cases. This journey enables you to:" ,
                detail : [ 
                    "Understand the basic logic of python programming" ,
                    "Use essential python functions to determine data characteristics statistically" ,
                    "Explore data in detail using python functions"
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,

    {
        id : 11 ,
        category : "Workshop" , 
        type : "Supporting" , 
        title : "Data Preparation" ,
        link : '/courses?id=11' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "The most critical steps of data analytics are how to prepare the data. " ,
        content : 
            {
                description : "The most critical steps of data analytics are how to prepare the data. A good data preparation will lead to the proper interpretation. This course helps you understand the stages of data preparation through many methods available. This Journey Enables you to:" ,
                detail : [ 
                    "Transform raw data prior to processing and analysis. It is an important step prior to processing and often involves reformatting data, making corrections to data and the combining of data sets to enrich data.",
                    "Clean and improve the Quality data. Preparing you to serve data presentation." 
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,

    {
        id : 12 ,
        category : "Workshop" , 
        type : "Supporting" , 
        title : "Basic Statistic" ,
        link : '/courses?id=12' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "Great analysis always comes from a great statistics understanding." ,
        content : 
            {
                description : "Great analysis always comes from a great statistics understanding. This course helps participants to understand the basic concepts about statistics with an excellent comprehensive concept delivery. This Journey Enables you to:" ,
                detail : [ 
                    "Be more precision to the Facts. Statistical methods present meaningful information. In other words, statistics helps in simplifying complex data to simple-to make them understandable." ,
                    "Determine the appropriate statistics for data interpretation according to the characteristics of the data" ,
                    "Predicts the future course of action of the phenomena." 
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,

    {
        id : 13 ,
        category : "Webinar" , 
        type : "Supporting" , 
        title : "Business Intelligence with Power BI" ,
        link : '/courses?id=13' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "No method is better than showing the data through a visual board. " ,
        content : 
            {
                description : "No method is better than showing the data through a visual board. This course helps participants to understand the concept of business intelligence, dashboarding, and visualizing using Microsoft Power BI. Participants will learn how to make a compelling dashboard that will effectively present the raw data. This Journey Enables you to:" ,
                detail : [ 
                    "Increases efficiency of operational processes." ,
                    "Gather the accurate and rich insights from the data provided." ,
                    "Set clear benchmarks based on historical and current data." ,
                    "Create analysis that can be shared in real-time across departments."
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,


    {
        id : 14 ,
        category : "Workshop" , 
        type : "Supporting" , 
        title : "Data Analysis Expression (DAX)" ,
        link : '/courses?id=14' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "Data Analysis Expression (DAX) is a part of Power BI that help user edit and operate the raw data. " ,
        content : 
            {
                description : "Data Analysis Expression (DAX) is a part of Power BI that help user edit and operate the raw data. Thus, good DAX skill is necessary to support a more excellent dashboard in Power BI. This course helps participants understand the concept of DAX, which commonly helps to make formulas and expressions in Microsoft Power BI, which makes us easier when visualizing data. This Journey Enables you to:" ,
                detail : [ 
                    "Help to streamline the use of Power BI in gathering powerful insights​." ,
                    "Makes it easier to formulate problems." ,
                    "Refine the strategy in formulating data." ,
                    "Skill up your potential of data management." 
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,


    {
        id : 15 ,
        category : "Workshop" , 
        type : "Supporting" , 
        title : "Data Pre-processing and Data Transformation" ,
        link : '/courses?id=15' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "Raw data is always dirty. Thus, data analysts ought to have a better point of view on how to manage it. " ,
        content : 
            {
                description : "Raw data is always dirty. Thus, data analysts ought to have a better point of view on how to manage it. This course helps participants understand how to prepare the data, including data pre-processing such as cleansing data and data transformation before it gets to data analytics. ​This Journey Enables you to:" ,
                detail : [ 
                    "Make data easier to read." ,
                    "Reduce the burden of representation in the data." ,
                    "Significantly reduce the duration of data mining ." ,
                    "Facilitate the process of data analysis in machine learning ."
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,

    {
        id : 16 ,
        category : "Webinar" , 
        type : "Supporting" , 
        title : "Data Analytics Methods and Tools​" ,
        link : '/courses?id=16' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "A wide range of new methods is available to make data speak thousand words. " ,
        content : 
            {
                description : "" ,
                detail : [ 
                    
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,


    {
        id  : 17 ,
        category : "Workshop" , 
        type : "All Entry" , 
        title : "Analytics for Business Optimization" ,
        link : '/courses?id=17' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "A wide range of new methods is available to make data speak thousand words. " ,
        content : 
            {
                description : "Besides a well-trained data analytics skill, a good business understanding is needed to maintain the goals. Thus, there will be no misleading decision that will affect the company. This course helps participants to understand the concept of data analytics that is commonly used for business optimization. ​This Journey Enable you to:​" ,
                detail : [ 
                    "Make the best possible decision is crucial to the success of any business and can really give you the competitive edge.​"
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,


    {
        id : 18 ,
        category : "Workshop" , 
        type : "All Entry" , 
        title : "Latest Trend in using Data Analytics for Business Transformation" ,
        link : '/courses?id=18' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "Becoming an interpreter of data is becoming a live long learner. " ,
        content : 
            {
                description : "Becoming an interpreter of data is becoming a live long learner. The scientific community will continually update the method of analysis as the data grows. This course helps participants understand the latest cases commonly used and concept of data analytics for business transformation.​ This journey enables you to:​" ,
                detail : [ 
                    "Promote excellent data quality & accessibility​" ,
                    "Effectively using analytics tools for business innovations​" ,
                    "Build a quantitative innovation culture​"
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
        
    } ,

    {
        id : 19 ,
        category : "Webinar" , 
        type : "All Entry" , 
        title : "Data Analytic Framework and Identification" ,
        link : '/courses?id=19' ,
        topic : 'Hot Topics' ,
        img : "./Demand/storyTel.png" ,
        body : "This course helps participants to understand the frameworks that commonly used in data analytics." ,
        content : 
            {
                description : "This course helps participants to understand the frameworks that commonly used in data analytics, such as descriptive analytics, predictive analytics and prescriptive analytics. This Journey Enables you to:" ,
                detail : [ 
                    "Find out the cause of a problem throughdata. It can minimize failures, both in the process of analysis and data storage.",
                    "Get data analysis that matches the facts in the field.",
                    "Plan a variety of options that have a good impact. "
                ],
                session : "1 Session" ,
                duration : "4 Hours (1 Day)" ,
                participants : "Unlimited" ,
                tools : "No Tools Needed"

            }     
    } 
]



const Experts = [
    {
        name : 'Imron Zuhri' ,
        img : '/experts/cto.png' ,
        title : 'Co-Founder & CTO of Dattabot' ,
        body : 'Introducing our first expert! Imron Zuhri has expertise in Big Data Analytics, Blockchain Technology, Agent-Based Modeling, Text Analytics, and Natural Language Processing, General AI, and many more. Imron has numerous experiences working for various international research institutes and multinational companies. He is also often invited as a keynote speaker at numerous National and International Conferences that talk about Data Analytics.' ,

    } ,

    {
        name : 'Regi Wahyu' ,
        img : '/experts/ceo.png' ,
        title : 'Founder & CEO of Dattabot' ,
        body : 'Regi Wahyu is a Serial Entrepreneur, Business Developer, with the goal of making a world-changing impact through exponential technology, managed growth strategies across the Asia Pacific region covering multinational companies.  Regi’s experience in mentorship is evident by being a Global Mentor for SDG Impact Accelerator and C-Level coach for Philip Morris International, National Bank Mandiri.' ,
        
    } ,

    {
        name : 'Juwita Winadwiastuti​' ,
        img : '/experts/juwita.png' ,
        title : 'Platform Architect & Blockchain Developer' ,
        body : 'Juwita is a Dattabot platform architect and currently leads the entire Dattabot data team. Apart from being the data team lead, Juwita is also the head of the Dattabot blockchain team.​ Juwita is also a frequent speaker at various activities from corporates, universities, to training activities for materials such as blockchain from basic to advanced level, spark, digital savvy for banking, and many more.',
        
    }
]


const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

const dataList = [
    'Data Storytelling' , 
    'Data Storytelling 2' ,
    'Data Storytelling 3' ,
]



export {Demand , Dojo , Comment , Course , Experts , settings , dataList}